import { jsx } from "panel";
import { TooltipEl } from "common/components/tooltip";
import { Placement } from "common/components/tooltip/types";
export function template() {
  const {
    t
  } = this.getContext("i18n");
  const timerText = this.helpers.getLastRefreshRelativeFormat();
  const isCompact = this.params.isCompact;
  const lastUpdatedText = isCompact ? timerText : t("components.last-updated.updated", {
    relativeTime: timerText
  });
  return /* @__PURE__ */ jsx("div", { sel: ".last-updated-container", attrs: {
    elref: "timeDisplayContainer"
  }, class: {
    "is-compact": isCompact
  }, "data-sentry-component": "template", "data-sentry-source-file": "template.tsx" }, /* @__PURE__ */ jsx("div", { sel: ".last-updated-text" }, lastUpdatedText), isCompact ? /* @__PURE__ */ jsx(TooltipEl, { attrs: {
    placement: Placement.Top,
    text: lastUpdatedText
  } }) : null);
}
